import { createSelector } from 'reselect';
import { getTimeFormat } from '../utils';
import studentSelector from './student';

export const timeFormatSelector = createSelector(studentSelector, (student) =>
    getTimeFormat(student?.preferences?.timeFormat),
);
